export default "__VITE_ASSET__BPmkbtxi__"